export interface TimedResult<T> {
  result: T;
  durationMs: number;
}

export function getElapsedDurationMs(startTime: number): number {
  return Math.round(performance.now() - startTime);
}

export function measureDuration<T>(operation: () => T): TimedResult<T> {
  const startTime = performance.now();
  const result = operation();

  return {
    result,
    durationMs: getElapsedDurationMs(startTime),
  };
}

export async function measureAsyncDuration<T>(operation: () => Promise<T>): Promise<TimedResult<T>> {
  const startTime = performance.now();
  const result = await operation();

  return {
    result,
    durationMs: getElapsedDurationMs(startTime),
  };
}
